// extracted by mini-css-extract-plugin
export default {"header":"expenses_salary_payrolls_header__ykW7I"};